import { socialMediaService } from "../../services/api";
import { SocialMedia } from "../../types/socialMedia/socialMedia";

let socialMediaList: SocialMedia[] = [
  {
    id: 1,
    iconPath: "/assets/icons/social_media/fp-square-p.svg",
    hoverIconPath: "/assets/icons/social_media/fp-square.svg",
    footerIconPath: "/assets/icons/social_media_footer/fp-p.svg",
    footerHoverIconPath: "/assets/icons/social_media_footer/fp.svg",
    menuIconPath: "/assets/icons/social_media_footer/fp-p.svg",
    redirectLink: "https://www.facebook.com/profile.php?id=100087101127695",
    name: "Facebook"
  },
  {
    id: 2,
    iconPath: "/assets/icons/social_media/inst-square-p.svg",
    hoverIconPath: "/assets/icons/social_media/inst-square.svg",
    footerIconPath: "/assets/icons/social_media_footer/inst-p.svg",
    footerHoverIconPath: "/assets/icons/social_media_footer/inst.svg",
    menuIconPath: "/assets/icons/social_media_footer/inst-p.svg",
    redirectLink: "https://www.instagram.com/polk_210/",
    name: "Instagram"
  },
  {
    id: 3,
    iconPath: "/assets/icons/social_media/teleg-square-p.svg",
    hoverIconPath: "/assets/icons/social_media/teleg-square.svg",
    footerIconPath: "/assets/icons/social_media_footer/teleg-p.svg",
    footerHoverIconPath: "/assets/icons/social_media_footer/teleg.svg",
    menuIconPath: "/assets/icons/social_media_footer/teleg-p.svg",
    redirectLink: "https://t.me/polk_210",
    name: "Telegram"
  },
  {
    id: 4,
    iconPath: "/assets/icons/social_media/ws-square-p.svg",
    hoverIconPath: "/assets/icons/social_media/ws-square.svg",
    footerIconPath: "/assets/icons/social_media_footer/ws-p.svg",
    footerHoverIconPath: "/assets/icons/social_media_footer/ws.svg",
    menuIconPath: "/assets/icons/social_media_footer/ws-p.svg",
    redirectLink: "https://whatsapp.com/channel/0029VarEV9F4Crfq4R475626",
    name: "WhatsApp"
  },
];

export async function loadSocialMedia() {
  try {
    // Call the API to get all social media entries
    const response = await socialMediaService.getAll();

    // Extract the data from the response
    const newSocialMediaList: SocialMedia[] = response.data;
    socialMediaList = newSocialMediaList.sort((a, b) => a.id - b.id);
  } catch (error) {
    console.error("Failed to load social media:", error);
    throw new Error("Не вдалося завантажити соціальні мережі");
  }
}

export function getSocialMedias() {
  return socialMediaList;
}
